import { GAME_ID, REDUX_ACTIONS, GAME_MODES } from '../../data/constants';

export const initState = {
  [GAME_MODES.READING]: {
    0: 0,
    1: 0,
  },
  [GAME_MODES.CLOZE]: {
    0: {},
    1: {},
  },
  [GAME_MODES.SUMMARY]: {
    0: {},
    1: {},
  },
};

const answersReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_INDEX:
      return {
        ...initState, // reset state to initial values for a new level
      };

    case REDUX_ACTIONS.SET_AVERAGE_WPM: {
      const {
        mode,
        test,
        avgWPM,
      } = payload;

      return {
        ...state,
        [mode]: {
          ...state[mode],
          [test]: avgWPM,
        },
      };
    }

    case REDUX_ACTIONS.SELECT_ANSWER: {
      const {
        mode,
        test,
        questionId,
        answer,
        isCorrect,
      } = payload;

      return {
        ...state,
        [mode]: {
          ...state[mode],
          [test]: {
            ...state[mode][test],
            [questionId]: {
              answer,
              isCorrect,
            },
          },
        },
      };
    }

    default:
      return state;
  }
};

export default answersReducer;
